import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-job',
    templateUrl: './job.component.html',
    styleUrls: ['./job.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, RouterLink]
})
export class JobComponent implements OnInit {
  id: string;
  jobTitle: string;
  responseJson: string;
  hasApiError = false;
  apiError: string;

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.api.getJobsId$(this.id).subscribe({
      next: (job) => {
        this.hasApiError = false;
        this.jobTitle = job.title;
        this.responseJson = JSON.stringify(job, null, 2).trim();
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }
}
